import type { ComponentProps, ReactNode } from "react";
import { Slider as SliderPrimitive } from "radix-ui";
import { cn } from "../../lib/utils";
import { focusRing } from "../ui/control-styles";

// The voice-threshold slider: a live level meter fills the track and a
// cursor-like handle (a vertical line with arrows pointing at the track) marks
// the threshold. Intentionally separate from the generic ShadCN Slider.
export function VoiceThresholdSlider({
  className,
  meter,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  "aria-valuetext": ariaValueText,
  ...props
}: ComponentProps<typeof SliderPrimitive.Root> & {
  /** Rendered inside the track, e.g. the live input level. */
  meter?: ReactNode;
}) {
  return (
    <SliderPrimitive.Root
      data-slot="voice-threshold-slider"
      className={cn(
        "relative flex h-7 w-full touch-none items-center select-none data-[disabled]:opacity-50",
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-2.5 w-full grow overflow-hidden rounded-full bg-input">
        {meter}
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-valuetext={ariaValueText}
        className={`block h-7 w-3 cursor-ew-resize rounded-sm text-foreground ${focusRing} disabled:pointer-events-none`}
      >
        <svg viewBox="0 0 12 28" className="size-full" fill="currentColor" aria-hidden="true">
          <path d="M1.5 1h9L6 6.5z" />
          <rect x="5.25" y="6" width="1.5" height="16" rx="0.75" />
          <path d="M1.5 27h9L6 21.5z" />
        </svg>
      </SliderPrimitive.Thumb>
    </SliderPrimitive.Root>
  );
}
